<template>
  <div class="min-h-full w-3/4">
    <div class="flex flex-col h-screen bg-white shadow-md">
      <div
        class="w-full py-3 pl-4 pr-4 bg-white text-black inline-flex items-center"
      >
        <div class="w-8">
          <button
            @click.stop="$emit('close')"
            class="align-middle focus:outline-none"
          >
            <img src="@/assets/icons/Exit.svg" />
          </button>
        </div>
        <div class="w-full">
          <h5
            class="text-gray-92 text-center text-base whitespace-no-wrap leading-4 font-semibold"
          >
            {{ state.transaction.buyer_company_name }}
          </h5>
        </div>
      </div>
      <div class="p-3 bg-slate-100 shadow-md">
        <h6
          class="text-gray-92 font-semibold text-sm ml-8"
          style="line-height: 21px; margin-left: 66px"
        >
          メッセージ
        </h6>
      </div>
      <div class="flex-grow w-full h-full overflow-y-auto pb-2">
        <div class="flex flex-col flex-auto h-full">
          <div v-if="state.messages.length == 0">
            <div
              class="flex justify-center mx-40 my-10 py-6 border leading-4"
              style="border-radius: 8px"
            >
              <div class="text-center text-gray-92 leading-4">
                <div class="text-base font-semibold">
                  メッセージはまだありません。
                </div>
                <div class="text-sm font-normal mt-2">
                  まずは、こちらからメッセージを送ってみましょう。<br />
                  初回のメッセージではごあいさつに加え、案件内容に近い実績を改めてアピールしたり、<br />
                  お打ち合わせ日時の候補を連絡すると、商談につながりやすくなります。
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="flex flex-col flex-auto flex-shrink-0 h-full pt-4 px-2"
          >
            <div class="flex flex-col h-full mb-4">
              <div class="flex flex-col h-full pb-2">
                <div
                  class="grid grid-cols-12 gap-y-4 overflow-y-auto mb-2"
                  ref="contentRef"
                  style="position: relative"
                >
                  <div
                    v-for="(message, i) in state.messages"
                    :key="message.id"
                    :id="message.id"
                    :ref="
                      (el) => {
                        if (el) messageRefs[i] = el;
                      }
                    "
                    class="flex"
                    :class="
                      message.deletedAt != null
                        ? 'col-start-5 col-end-9'
                        : message.from == 'they'
                        ? 'col-start-3 col-end-10'
                        : 'col-start-4 col-end-11'
                    "
                    @mouseover="state.hoveringMessageId = message.id"
                    @mouseleave="state.hoveringMessageId = 0"
                  >
                    <div
                      v-if="message.deletedAt != null"
                      class="flex justify-center w-full"
                    >
                      <div
                        class="flex items-center h-6 border rounded-full py-1 text-center"
                        style="width: 200px"
                      >
                        <div
                          class="w-full text-xs text-gray-62 font-semibold leading-4 text-center"
                        >
                          <span v-if="message.type == 'file'">{{
                            message.from == 'they'
                              ? 'ファイルが削除されました'
                              : 'ファイルを削除しました'
                          }}</span>
                          <span v-else
                            >{{
                              message.from == 'they'
                                ? 'メッセージが削除されました'
                                : 'メッセージを削除しました'
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="
                        message.from == 'they' && message.type == 'text'
                      "
                      class="flex flex-col w-full mr-8"
                    >
                      <div class="flex flex-row items-center">
                        <div
                          class="text-sm bg-slate-100 px-6 py-4 they-rounded w-full"
                          :class="{
                            'whitespace-pre-wrap': hasNewline(message.content),
                          }"
                          style="font-size: 13px; line-height: 20px"
                        >
                          <div>
                            {{ message.content }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="flex flex-row items-center justify-between mt-2"
                      >
                        <div>
                          <span class="title-sm text-gray-92">{{
                            message.user.name
                          }}</span
                          ><span class="body-md text-gray-62 ml-2">{{
                            message.company.name
                          }}</span>
                        </div>
                        <div class="body-sm text-gray-62">
                          {{ message.createdAt }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-else-if="
                        message.from == 'they' && message.type == 'file'
                      "
                      class="flex flex-col w-full cursor-pointer mr-8"
                    >
                      <div
                        class="text-sm bg-white py-2 px-3 w-full"
                        style="background: #ffe9e9"
                      >
                        <a
                          class="flex flex-row justify-between text-sm"
                          style="line-height: 21px"
                          :href="message.file.url"
                          target="_blank"
                        >
                          <div
                            class="text-gray-92 font-semibold"
                            style="padding: 2px 12px"
                          >
                            {{ message.file.name
                            }}<span class="text-gray-62"
                              >（{{ message.file.filesize_string }}）</span
                            >
                          </div>
                          <div>
                            <img
                              class="w-6 h-6"
                              src="@/assets/icons/FileDL.svg"
                            />
                          </div>
                        </a>
                      </div>
                      <div
                        class="flex flex-row items-center justify-between mt-2"
                      >
                        <div>
                          <span class="title-sm text-gray-92">{{
                            message.user.name
                          }}</span
                          ><span class="body-md text-gray-62 ml-2">{{
                            message.company.name
                          }}</span>
                        </div>
                        <div class="body-sm text-gray-62">
                          {{ message.createdAt }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="message.from == 'we' && message.type == 'file'"
                      class="flex flex-col w-full cursor-pointer"
                    >
                      <div class="flex items-end">
                        <div
                          class="text-gray-500 leading-4 text-xs w-6 mr-2 mb-1"
                        >
                          <span v-if="message.isRead">既読</span>
                        </div>
                        <div class="flex flex-row flex-1 items-center relative">
                          <div
                            class="text-sm bg-white py-2 px-3 w-full hover:opacity-50"
                            :class="{
                              'opacity-50':
                                message.id == state.hoveringMessageId &&
                                message.canDelete === 1,
                            }"
                            style="background: #ffe9e9"
                          >
                            <a
                              v-if="message.file.url"
                              class="flex flex-row justify-between text-sm"
                              style="line-height: 21px"
                              :href="message.file.url"
                              target="_blank"
                            >
                              <div
                                class="text-gray-92 font-semibold"
                                style="padding: 2px 12px"
                              >
                                {{ message.file.name
                                }}<span class="text-gray-62"
                                  >（{{ message.file.filesize_string }}）</span
                                >
                              </div>
                              <div>
                                <img
                                  class="w-6 h-6"
                                  src="@/assets/icons/FileDL.svg"
                                />
                              </div>
                            </a>
                            <div
                              v-else
                              class="flex flex-row justify-between text-sm"
                              style="line-height: 21px"
                            >
                              <div
                                class="text-gray-92 font-semibold"
                                style="padding: 2px 12px"
                              >
                                {{ message.file.name
                                }}<span class="text-gray-62"
                                  >（{{ message.file.filesize_string }}）</span
                                >
                              </div>
                            </div>
                          </div>
                          <div
                            v-show="
                              message.id == state.hoveringMessageId &&
                              message.canDelete === 1
                            "
                            class="absolute top-0 right-0 -mt-2 mr-10"
                          >
                            <button
                              class="bg-white focus:outline-none"
                              style="
                                padding: 10px;
                                box-shadow: 0px 0px 8px rgba(189, 189, 189, 0.5);
                                border-radius: 8px;
                              "
                              @click="confirmDeleteFile(message.id)"
                            >
                              <img
                                style="width: 20px; height: 20px"
                                src="@/assets/icons/Trash1.18.svg"
                              />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        class="flex flex-row-reverse items-center justify-between mt-2"
                      >
                        <div>
                          <span class="title-sm text-gray-92">{{
                            message.user.name
                          }}</span>
                        </div>
                        <div class="body-sm text-gray-62 ml-8">
                          {{ message.createdAt }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="message.from == 'we' && message.type == 'text'"
                      class="flex items-center justify-start flex-row-reverse w-full"
                    >
                      <div class="relative flex flex-col w-full">
                        <div class="flex items-end">
                          <div class="text-gray-500 leading-4 text-xs w-8 mb-1">
                            <span v-if="message.isRead">既読</span>
                          </div>
                          <div
                            class="text-sm bg-slate-100 px-6 py-4 we-rounded w-full"
                            :class="{
                              'opacity-50':
                                message.id == state.hoveringMessageId &&
                                message.canDelete === 1,
                              'whitespace-pre-wrap': hasNewline(
                                message.content
                              ),
                            }"
                          >
                            {{ message.content }}
                          </div>
                        </div>
                        <div
                          class="flex flex-row-reverse items-center justify-between mt-2"
                        >
                          <div>
                            <span class="title-sm text-gray-92">{{
                              message.user.name
                            }}</span>
                          </div>
                          <div class="body-sm text-gray-62 ml-8">
                            {{ message.createdAt }}
                          </div>
                        </div>
                        <div
                          v-show="
                            message.id == state.hoveringMessageId &&
                            message.canDelete === 1
                          "
                          class="absolute top-0 right-0 -mt-2 mr-10"
                        >
                          <button
                            class="bg-white focus:outline-none"
                            style="
                              padding: 10px;
                              box-shadow: 0px 0px 8px rgba(189, 189, 189, 0.5);
                              border-radius: 8px;
                            "
                            @click="confirmDeleteMessage(message.id)"
                          >
                            <img
                              style="width: 20px; height: 20px"
                              src="@/assets/icons/Trash1.18.svg"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="message.from == 'we' && message.type == 'qa'"
                      class="flex items-center justify-start flex-row-reverse w-full"
                    >
                      <div class="relative flex flex-col w-full">
                        <div class="flex items-end">
                          <div class="text-gray-500 leading-4 text-xs w-8 mb-1">
                            <span v-if="message.isRead">既読</span>
                          </div>
                          <div
                            class="text-sm bg-slate-100 px-6 py-4 we-rounded w-full whitespace-pre-wrap"
                            :class="{
                              'opacity-50':
                                message.id == state.hoveringMessageId &&
                                message.canDelete === 1,
                            }"
                          >
                            <div class="mt-2 mb-4">
                              {{ message.company.name }}
                              より質問リストへの回答が届きました。
                            </div>
                            <div
                              v-for="(qa, idx) in message.qa_list"
                              :key="qa.id"
                              class="mt-4 pb-4"
                              :class="
                                idx !== message.qa_list.length - 1
                                  ? 'border-b border-gray-12'
                                  : ''
                              "
                            >
                              <div class="flex mb-1">
                                <div
                                  style="min-width: 20px; height: 20px"
                                  class="flex items-center justify-center rounded-full bg-slate-300"
                                >
                                  <img src="@/assets/icons/AlphabetQ.svg" />
                                </div>
                                <div
                                  class="ml-3 font-semibold whitespace-pre-wrap"
                                >
                                  {{ qa.question }}
                                </div>
                              </div>
                              <div class="flex">
                                <div
                                  style="
                                    min-width: 20px;
                                    height: 20px;
                                    background-color: rgba(108, 126, 206, 0.1);
                                  "
                                  class="flex items-center justify-center rounded-full mt-1"
                                >
                                  <img src="@/assets/icons/AlphabetA.svg" />
                                </div>
                                <div
                                  class="ml-3 mt-0.5 leading-6 whitespace-pre-wrap"
                                >
                                  {{ qa.answer }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="flex flex-row-reverse items-center justify-between mt-2"
                        >
                          <div>
                            <span class="title-sm text-gray-92">{{
                              message.user.name
                            }}</span>
                          </div>
                          <div class="body-sm text-gray-62 ml-8">
                            {{ message.createdAt }}
                          </div>
                        </div>
                        <div
                          v-show="
                            message.id == state.hoveringMessageId &&
                            message.canDelete === 1
                          "
                          class="absolute top-0 right-0 -mt-2 mr-10"
                        >
                          <button
                            class="bg-white focus:outline-none"
                            style="
                              padding: 10px;
                              box-shadow: 0px 0px 8px rgba(189, 189, 189, 0.5);
                              border-radius: 8px;
                            "
                            @click="confirmDeleteMessage(message.id)"
                          >
                            <img
                              style="width: 20px; height: 20px"
                              src="@/assets/icons/Trash1.18.svg"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="py-4 px-40 w-full bg-white"
        style="box-shadow: 0 -4px 5px -6px #333"
        v-if="state.transaction.canSendMessage == true"
      >
        <div class="flex flex-col items-center h-full rounded-xl w-full">
          <div class="flex-grow w-full pb-4">
            <textarea
              class="flex w-full text-gray-92 border-0 focus:outline-none resize-none leading-5 text-sm"
              style="height: 100px"
              :placeholder="
                state.transaction.buyer_company_name
                  ? state.transaction.buyer_company_name + 'へのメッセージ'
                  : ''
              "
              v-model="state.messageValueModel"
              @keydown.meta.enter="handleSendMessage"
              @keydown.ctrl.enter="handleSendMessage"
              @blur="saveMsg2Storage()"
            />
            <div
              v-if="state.fileValueModel && state.fileValueModel.name"
              class="text-sm bg-white py-2 px-3 w-full mt-2"
              style="background: #ffe9e9"
            >
              <div
                class="flex flex-row justify-between text-sm"
                style="line-height: 21px"
              >
                <div
                  class="text-gray-92 font-semibold"
                  style="padding: 2px 12px"
                >
                  {{ state.fileValueModel.name
                  }}<span class="text-gray-62"
                    >（{{ state.fileValueModel.filesize_string }}）</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-row-reverse h-8 w-full items-center">
            <button
              class="flex justify-center items-center gap-1 rounded-lg flex-shrink-0 ml-2"
              style="width: 206px; height: 40px"
              @click="handleSendMessage"
              :class="
                state.isMessageValueEmpty
                  ? 'bg-gray-08 cursor-not-allowed'
                  : 'bg-primary-light-high hover:bg-primary-state-light-high-hover focus:bg-primary-state-light-high-focused active:bg-primary-state-light-high-pressed'
              "
              :disabled="state.isMessageValueEmpty"
            >
              <BaseIcon
                icon-name="send"
                :icon-color="state.isMessageValueEmpty ? '#06101a' : 'white'"
                :opacity="state.isMessageValueEmpty ? 0.3 : 1"
              />
              <span
                class="button-md focus:outline-none text-white"
                :class="{
                  'text-white': !state.isMessageValueEmpty,
                  'text-gray-38': state.isMessageValueEmpty,
                }"
              >
                送信する
              </span>
            </button>
            <input
              id="upload-file"
              ref="messageUploadFileRef"
              type="file"
              accept="*"
              @change.prevent="processUploadFile"
              class="hidden"
            />
            <button
              class="flex justify-center items-center gap-2 bg-white border border-solid border-gray-38 rounded-lg flex-shrink-0 hover:bg-gray-04 focus:bg-gray-12 active:bg-gray-10"
              style="width: 150px; height: 40px"
              @click="messageUploadFileRef.click()"
            >
              <BaseIcon icon-name="clip" icon-color="#06101A" opacity="0.62" />
              <span class="button-md focus:outline-none text-gray-92">
                添付ファイル
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ModalChargeConfirm
      :isShow="state.showConfirmSendMessage"
      @cancel="state.showConfirmSendMessage = false"
      @ok="
        state.showConfirmSendMessage = false;
        state.chargeConfirmRequired = false;
        sendMessage(true);
      "
    ></ModalChargeConfirm>
    <modalDialog
      :show-dialog="state.showDeleteMessageConfirmDialog === true"
      title="このメッセージを削除しますか？"
      close-text="キャンセル"
      close-text-border-class="border"
      close-text-color-class="text-gray-62"
      close-text-bg-class="bg-white"
      ok-text="削除"
      ok-text-color-class="text-white"
      ok-text-bg-class="bg-danger"
      @ok-action="deleteMessage"
      @close-dialog="state.showDeleteMessageConfirmDialog = false"
    >
      <div>この操作は元に戻せません。</div>
    </modalDialog>
    <modalDialog
      :show-dialog="state.showDeleteFileConfirmDialog === true"
      title="このファイルを削除しますか？"
      close-text="キャンセル"
      close-text-border-class="border"
      close-text-color-class="text-gray-62"
      close-text-bg-class="bg-white"
      ok-text="削除"
      ok-text-color-class="text-white"
      ok-text-bg-class="bg-danger"
      @ok-action="deleteMessage"
      @close-dialog="state.showDeleteFileConfirmDialog = false"
    >
      <div>この操作は元に戻せません。</div>
    </modalDialog>
  </div>
</template>
<script>
import {
  inject,
  reactive,
  ref,
  watch,
  toRefs,
  onMounted,
  onUnmounted,
  nextTick,
  computed,
} from 'vue';
import { useRoute } from 'vue-router';
import modalDialog from '@/components/modalDialog.vue';
import ModalChargeConfirm from '@/components/ModalChargeConfirm.vue';
import axios from '@/utils/axiosAuth.js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import BaseIcon from '@/components/BaseIcon';

const filesizeToString = (filesize) => {
  const KB = 1024;
  const MB = 1024 * 1024;

  if (filesize > MB) {
    return Math.round(filesize / MB) + ' MB';
  } else if (filesize > KB) {
    return Math.round(filesize / KB) + ' KB';
  }
  return filesize + ' bytes';
};
export default {
  props: {
    companyName: String,
  },
  components: {
    modalDialog,
    ModalChargeConfirm,
    BaseIcon,
  },
  emits: ['close'],
  setup(props, { emit }) {
    const route = useRoute();
    const globalStore = inject('globalStore');
    const globalMethods = inject('globalMethods');
    const { showModal } = toRefs(props);
    const state = reactive({
      hoveringMessageId: 0,
      messageId: null,
      showDeleteMessageConfirmDialog: false,
      showDeleteFileConfirmDialog: false,
      showConfirmSendMessage: false,
      chargeConfirmRequired: false,
      transaction: {},
      messages: [],
      messageValueModel: '',
      fileValueModel: null,
      isMessageValueEmpty: computed(() => {
        return (
          state.messageValueModel.replace(/\s/g, '') === '' &&
          state.fileValueModel === null
        );
      }),
    });
    const isShowNewPlan = process.env.VUE_APP_IS_NEW_PLAN === 'true';

    const confirmDeleteMessage = (messageId) => {
      state.showDeleteMessageConfirmDialog = true;
      state.messageId = messageId;
    };
    const confirmDeleteFile = (messageId) => {
      state.showDeleteFileConfirmDialog = true;
      state.messageId = messageId;
    };
    const contentRef = ref(null);
    const messageRefs = ref([]);
    const messageUploadFileRef = ref(null);
    const scrollToBottom = (scrollBehavior = {}) => {
      if (contentRef.value) {
        contentRef.value.scrollTo({
          top: contentRef.value.scrollHeight,
          ...scrollBehavior,
        });
      }
    };
    const scrollToAnchorHashMessage = (hash) => {
      if (contentRef.value && messageRefs.value) {
        for (const [idx] of Object.entries(messageRefs.value)) {
          if (messageRefs.value[idx]) {
            let id = hash.substr(1);
            let elm = messageRefs.value[idx];
            if (elm.id === id) {
              contentRef.value.scrollTo({
                top: elm.offsetTop,
              });
            }
          }
        }
      }
    };
    const hasNewline = (text) => {
      return text.indexOf('\n') >= 0;
    };
    const makeMessageRead = (id) => {
      axios.post(`/transaction-service-messages/${id}/read`).catch((e) => {
        // TODO: エラーメッセージ確認
        globalMethods.updateModal(
          true,
          'エラーが発生しました。',
          e.systemMessage || '',
          e.callback
        );
        globalMethods.sendLog(e);
      });
    };
    const deleteMessage = () => {
      state.showDeleteMessageConfirmDialog = false;
      state.showDeleteFileConfirmDialog = false;
      axios
        .post(
          `/transactions/${route.params.id}/messages/${state.messageId}/delete`
        )
        .then(() => {
          for (const [idx, message] of Object.entries(state.messages)) {
            if (message.id === state.messageId) {
              state.messages[idx].content = null;
              state.messages[idx].file = null;
              state.messages[idx].deletedAt = new Date();
              state.messageId = null;
              break;
            }
          }
        })
        .catch((e) => {
          // TODO: エラーメッセージ確認
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };
    const handleSendMessage = () => {
      if (state.chargeConfirmRequired && !isShowNewPlan) {
        state.showConfirmSendMessage = true;
        return;
      }
      sendMessage();
    };

    const sendMessage = async (chargeConfirmAgreed = false) => {
      if (
        state.messageValueModel.replace(/\s/g, '') === '' &&
        state.fileValueModel === null
      ) {
        return;
      }

      let data = {};
      if (state.messageValueModel) {
        data.content = state.messageValueModel;
      }
      if (state.fileValueModel) {
        data.attached_file = state.fileValueModel;
      }
      if (chargeConfirmAgreed) {
        await agreeChargeConfirm();
      }

      axios
        .post(`/transactions/${route.params.id}/messages/register`, data)
        .then(async (response) => {
          for (const message of response.data.data) {
            if (message) {
              message.from = 'we';
              message.type = 'text';
              if (message.attached_file_size && message.file) {
                message.type = 'file';
                message.file.filesize_string = filesizeToString(
                  message.attached_file_size
                );
              }
              message.user = {
                id: message.seller_id,
                name: message.seller_name,
              };
              message.company = {
                name: message.seller_company_name,
              };
              message.canDelete = 1;
              state.messages.push(message);

              if (state.messages.length == 1) {
                emit('sent-message');
              }
            }
          }
          state.messageValueModel = '';
          state.fileValueModel = null;
          await nextTick();
          scrollToBottom({ behavior: 'smooth' });
        })
        .catch((e) => {
          // TODO: エラーメッセージ確認
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
      deleteMsgFromStorage();
    };

    const agreeChargeConfirm = async () => {
      await axios
        .post(
          `/transactions/${route.params.id}/charge-confirm-agreement/register`
        )
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    const processUploadFile = (e) => {
      const files = e.target.files;
      if (files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          state.fileValueModel = {
            name: files[0].name,
            content: reader.result,
            filesize_string: filesizeToString(files[0].size),
          };
        };
        return;
      }
      state.fileValueModel = null;
    };

    const isElementInContentViewport = (el) => {
      if (contentRef.value) {
        const contentViewport = contentRef.value.getBoundingClientRect();
        const rect = el.getBoundingClientRect();
        return rect.top >= contentViewport.top - 1;
      }
      return false;
    };

    const handleReadMessage = () => {
      if (messageRefs.value) {
        for (const [idx] of Object.entries(messageRefs.value)) {
          if (messageRefs.value[idx]) {
            if (
              isElementInContentViewport(messageRefs.value[idx]) &&
              state.messages[idx].from == 'they' &&
              state.messages[idx].isRead == false
            ) {
              state.messages[idx].isRead = true;
              makeMessageRead(state.messages[idx].id);
            }
          }
        }
      }
    };
    const handleScroll = () => {
      handleReadMessage();
    };

    const saveMsg2Storage = () => {
      if (state.messageValueModel.replace(/\s/g, '') === '') return;

      try {
        let allMessages = JSON.parse(
          localStorage.getItem(`user${globalStore.user.id}`)
        );

        let transactionServiceMsg = [];
        if (allMessages) {
          transactionServiceMsg = allMessages.filter(
            (e) => e.tx_id !== route.params.id
          );
        }
        transactionServiceMsg.push({
          tx_id: route.params.id,
          msg: state.messageValueModel,
        });

        localStorage.setItem(
          `user${globalStore.user.id}`,
          JSON.stringify(transactionServiceMsg)
        );
      } catch (e) {
        globalMethods.sendLog(e);
      }
    };

    const initMsgFromStorage = () => {
      try {
        let allMessages = JSON.parse(
          localStorage.getItem(`user${globalStore.user.id}`)
        );
        if (allMessages) {
          let transactionServiceMsg = allMessages.find(
            (e) => e.tx_id === route.params.id
          );
          state.messageValueModel = transactionServiceMsg
            ? transactionServiceMsg.msg
            : '';
        }
      } catch (e) {
        globalMethods.sendLog(e);
      }
    };

    const deleteMsgFromStorage = () => {
      try {
        let allMessages = JSON.parse(
          localStorage.getItem(`user${globalStore.user.id}`)
        );

        if (allMessages) {
          let transactionServiceMsg = allMessages.filter(
            (e) => e.tx_id !== route.params.id
          );
          localStorage.setItem(
            `user${globalStore.user.id}`,
            JSON.stringify(transactionServiceMsg)
          );
        }
      } catch (e) {
        globalMethods.sendLog(e);
      }
    };

    onMounted(async () => {
      await axios
        .get(`/transactions/${route.params.id}/messages`)
        .then(async (response) => {
          // TODO: validate response.data.data.messages is exists
          state.transaction = response.data.data.transaction;
          state.chargeConfirmRequired =
            response.data.data.is_charge_confirm_required;
          for (let i = 0; i < response.data.data.messages.length; i++) {
            let message = response.data.data.messages[i];
            message.from = message.from == 'seller' ? 'we' : 'they';
            if (message.type === 'file' && message.file) {
              message.file.filesize_string = filesizeToString(
                message.file.filesize
              );
            }
            state.messages.push(message);
          }
          await nextTick();
          if (route.hash) {
            scrollToAnchorHashMessage(route.hash);
          } else {
            scrollToBottom();
          }
          disableBodyScroll(contentRef);
          if (contentRef.value) {
            handleReadMessage();
            contentRef.value.addEventListener('scroll', handleScroll);
          }
        })
        .catch((e) => {
          // TODO: エラーメッセージ確認
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
      initMsgFromStorage();
    });
    onUnmounted(() => {
      state.transaction = {};
      state.messages = [];
      enableBodyScroll(contentRef);
    });
    watch(showModal, (newValue, oldValue) => {
      if (oldValue === false && newValue === true) {
        scrollToBottom();
      }
    });
    return {
      state,
      deleteMessage,
      sendMessage,
      handleSendMessage,
      confirmDeleteMessage,
      confirmDeleteFile,
      contentRef,
      messageRefs,
      messageUploadFileRef,
      scrollToBottom,
      processUploadFile,
      hasNewline,
      saveMsg2Storage,
    };
  },
};
</script>

<style lang="scss" scoped>
.they-rounded {
  border-radius: 16px 16px 16px 0px;
}
.we-rounded {
  border-radius: 16px 16px 0px 16px;
}
</style>
